function getDefaultState() {
    return {
        isLoading: false,
        requisicoes:[]
    };
  }
  
  const state = getDefaultState();
  
  const getters = {};
  
  const mutations = {
    habilitarLoading(state, status) {
      state.isLoading = status;
    },
    addRequisicao(state, requisicao){
      state.requisicoes.push(requisicao);
    },
    resetRequisicoes(state){
      state.requisicoes = []
    }
  };
  
  const actions = {
    habilitarLoading: ({commit}, status) => {
      commit('habilitarLoading', status);
    },
    addRequisicao: ({commit}, requisicao) => {
      commit('addRequisicao',requisicao);
    },
    resetRequisicoes: ({commit}) => {
      commit('resetRequisicoes');
    }
  };
  
  export default { namespaced: true, state, mutations, getters, actions };
    